import { Component, ViewChild } from '@angular/core';
import { Nav, Events, MenuController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { ConstantsProvider } from '../providers/constants/constants';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Network } from '@ionic-native/network';

@Component({
    templateUrl: 'app.html'
})

export class MyApp 
{
    @ViewChild(Nav) nav: Nav;
    rootPage = 'LoginPage';

    public pages: Array<{title: string, bck_clr:string, subgroup:string, component: any}>;
    public links : any;
    private store_name : string;
    private loggedInUserName : string;
    private emp_id  : any = '';
    private app_runnig_mode : number;
    public page_controller : string = '';
    public page_method : string = '';
    public page_title : string = '';
    constructor(
        platform: Platform,
        statusBar: StatusBar, 
        splashScreen: SplashScreen,
        public storage : Storage,
        public myconfig : ConstantsProvider,
        public events: Events,
        public menuCtrl: MenuController,
        private network: Network
    )
    {
        platform.ready().then(() => 
        {
            statusBar.styleDefault();
            splashScreen.hide();
            this.registerToNetworkEvents();
        });

        this.storage.get('app_runnig_mode').then((data) => {
            this.app_runnig_mode = data;
        });
        this.links = {"ChangePassword" : "ChangepasswordPage"};
        
        this.events.subscribe('update:menu', () => 
        {
            this.storage.get('store_name').then((data) => 
            {
                this.store_name = data;
            });
            this.storage.get('user_name').then((data) => 
            {
                this.loggedInUserName = data;
            });
            this.storage.get('user_id').then((data) => {
                this.emp_id = data;
            });

            this.myconfig.sendGetRequest('/Users/generateUserMenuBarLinks')
            .then(data => 
            {
                var response : any = data;
                if(response.success == 1)
                {
                    this.pages = response.data;
                }
                else
                {
                    this.doLogout();
                }
            });
        });
        this.events.publish('update:menu');

        events.subscribe('user:invalid', () =>
        {
            this.nav.setRoot('HomePage');
        });
        // this.menuCtrl.enable(false, 'menu');
    }


    ionViewWillEnter() 
    {
        // this.menuCtrl.enable(false, 'menu');
    }





    openPage(page, page_controller, page_method, page_title) 
    {
        this.page_controller = page_controller;
        this.page_method = page_method;
        this.page_title = page_title;
        this.myconfig.sendGetRequest('/Users/checkUserHasPrivilegeToGivenCotrollerAndMethod/'+this.page_controller+'/'+this.page_method)
        .then(data => 
        {
            var response : any = data;
            if(response.success == 1)
            {
                this.nav.setRoot(page, {"page_title" : page_title});
            }
            else if(response.success == 2) // user dont have privilege
            {
                alert(response.msg);
                this.nav.setRoot('HomePage');
            }
            else{ // session expired
                alert(response.msg);
                this.doLogout();
            }
        });
    }






    doLogout()
    {
        this.myconfig.sendGetRequest('/login/doLogout/' + this.emp_id)
        .then(data => 
        {
            this.pages = [];
            this.storage.remove('store_id').then(() => { });
            this.storage.remove('user_access_key').then(() => { });
            this.storage.remove('store_name').then(() => { });
            this.storage.remove('feedback_url_token').then(() => { });
            this.storage.remove('user_name').then(() => { });
            this.storage.remove('user_id').then(() => { });
            this.storage.remove('app_runnig_mode').then(() => { });
            this.storage.remove('app_runnig_mode_string').then(() => { });
            this.storage.remove('tfs_printer_address').then(() => { });
            this.storage.remove('ds_prefix').then(() => {
                this.nav.setRoot('LoginPage');
            });
            this.loggedInUserName = '';
            this.emp_id = '';
            this.store_name = '';
        });


        this.pages = [];
        this.storage.remove('store_id').then(() => { });
        this.storage.remove('user_access_key').then(() => { });
        this.storage.remove('store_name').then(() => { });
        this.storage.remove('feedback_url_token').then(() => { });
        this.storage.remove('user_name').then(() => { });
        this.storage.remove('user_id').then(() => { });
        this.storage.remove('app_runnig_mode').then(() => { });
        this.storage.remove('app_runnig_mode_string').then(() => { });
        this.storage.remove('tfs_printer_address').then(() => { });
        this.storage.remove('ds_prefix').then(() => {
            this.nav.setRoot('LoginPage');
        });
        this.loggedInUserName = '';
        this.emp_id = '';
        this.store_name = '';
    }





    shutdownOfflineServer()
    {
        this.myconfig.sendGetRequest('/login/shutdownCommandForOfflineServer')
        .then(data => 
        {
            var response : any = data;
            alert( response.msg );
        });
    }





    registerToNetworkEvents()
    {
        this.network.onConnect().subscribe( (data) => {
            this.events.publish('network:online', data); 
        }, error => console.error(error));

        this.network.onDisconnect().subscribe( (data) => {
          this.events.publish('network:offline', data);
        }, error => console.error(error));
    }



}


// WEBPACK FOOTER //
// ./src/app/app.component.ts